<template lang="pug">
  .searchPanel
    .simpleSearch(v-if="searchObject.simpleSearch", key="simpleSearch")
      form(@submit.prevent="$emit('search', searchObject.simpleFieldValue)")
        el-input(
          placeholder="Informe a descrição",
          v-model="searchObject.simpleFieldValue",
          class="input-with-select",
          @input="$emit('input', searchObject.simpleFieldValue)",
        )
          el-button(
            slot="append",
            icon="el-icon-search",
            @click="$emit('search', searchObject.simpleFieldValue)"
          )
</template>

<script>

export default {

  props: {
    placeHolder: {
      type: String,
      default: 'Informe a descrição',
      required: false
    }
  },

  data () {
    return {
      searchObject: {
        simpleFieldValue: '',
        simpleSearch: true
      }
    }
  },

  methods: {

    limpar () {
      if (this.searchObject.simpleSearch) {
        this.searchObject.simpleFieldValue = ''
      }
      this.$emit('clear')
    }

  }

}
</script>

<style lang="scss" scoped>

  .searchPanel {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    .button-group {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 15px;
    }

    .no-padding{
      padding: 0;
    }

    .panel{

      .margin-top{
        margin-top: 10px;
      }

      .titulo{
        font-size: 14px;
      }

    }

    .btn {
      padding: 8px;
    }

  }

  .full-width {
    width: -webkit-fill-available;
  }

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppSearchDespachos.vue